import { ZwheelExperience } from '../types/service.types';

export const ZWHEEL_EXPERIENCE_DATA: ZwheelExperience = {
  warranty: {
    id: 'warranty',
    title: '5 Años de Garantía',
    description: 'Disfruta de la máxima tranquilidad con nuestra garantía extendida líder en el sector.',
    icon: 'ShieldCheck'
  },
  repair: {
    id: 'repair',
    title: 'Servicio de Reparación',
    description: 'Servicio integral de recogida y reparación. Nos encargamos de todo para que tú solo te preocupes de rodar.',
    icon: 'Wrench'
  },
  support: {
    id: 'support',
    title: 'Servicio Postventa',
    description: 'Atención personalizada por teléfono y email. Compromiso de respuesta en menos de 48h.',
    icon: 'Headphones'
  },
  parts: {
    id: 'parts',
    title: 'Recambios Originales',
    description: 'Mantén tu ZWheel como el primer día con piezas 100% originales y certificadas.',
    icon: 'Settings'
  },
  accessories: {
    id: 'accessories',
    title: 'Accesorios',
    description: 'Personaliza tu experiencia con nuestra gama exclusiva de accesorios oficiales.',
    icon: 'ShoppingBag'
  },
  financing: {
    id: 'financing',
    title: 'Financiación Flexible',
    description: 'Opciones de pago a tu medida. Disfruta de tu ZWheel ahora y paga cómodamente.',
    icon: 'CreditCard'
  },
  techCenters: [] // 这里可以后续扩展具体的中心列表
};

export const TECH_CENTER_INFO = {
  title: 'Centros de Asistencia Técnica',
  description: 'Contamos con una amplia red de servicios técnicos oficiales en toda España. Encuentra tu centro más cercano para un servicio rápido y personalizado.',
  action: 'Encontrar mi centro'
};
